import confetti from 'canvas-confetti';
import { prefersReducedMotion, themeVar } from '../ui/dom.js';

let fire = null;
const listeners = new Set();

/** Lets the phone recap video throw its own confetti (this canvas is drawn by a worker and can't be copied). */
export function onCelebrate(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function launcher() {
  if (!fire) {
    const canvas = document.getElementById('confetti-canvas');
    fire = confetti.create(canvas, { resize: true, useWorker: true });
  }
  return fire;
}

/** Full-screen celebration in the active theme's colours. */
export function celebrate() {
  for (const listener of listeners) listener();
  const shoot = launcher();
  const colors = themeVar('--tk-confetti', { list: true });
  const reduced = prefersReducedMotion();

  shoot({
    particleCount: reduced ? 60 : 170,
    spread: 100,
    startVelocity: 52,
    origin: { x: 0.5, y: 0.55 },
    colors,
    scalar: 1.1,
    ticks: 260,
  });
  if (reduced) return;

  setTimeout(
    () =>
      shoot({ particleCount: 60, spread: 140, startVelocity: 30, origin: { x: 0.5, y: 0.35 }, colors, shapes: ['star'], scalar: 1.4 }),
    280,
  );

  // Side cannons for ~2.4 s.
  const end = performance.now() + 2400;
  (function frame() {
    shoot({ particleCount: 4, angle: 60, spread: 58, startVelocity: 62, origin: { x: 0, y: 0.75 }, colors });
    shoot({ particleCount: 4, angle: 120, spread: 58, startVelocity: 62, origin: { x: 1, y: 0.75 }, colors });
    if (performance.now() < end) requestAnimationFrame(frame);
  })();
}
